import React, { FC } from 'react';
import { Box, TextButton } from '@wix/design-system';
import { marketplaceHeaderClientGenericClick } from '@wix/bi-logger-marketplace/v2';
import { useBi } from '../../Hooks/useBi';
import { Category, Service } from '../models';
import { dataHooks, getServiceLink } from '../utils/constants';

interface MarketplaceServiceLinkProps {
  service: Service | Category;
  categoryPathName?: string;
  marketplaceUrlPrefix: string;
  pageName: string;
}

const MarketplaceServiceLink: FC<MarketplaceServiceLinkProps> = ({
  service,
  categoryPathName,
  marketplaceUrlPrefix,
  pageName,
}) => {
  const logger = useBi();
  const isSingleServiceLink = Boolean(categoryPathName);
  const hrefLink = getServiceLink(
    marketplaceUrlPrefix,
    service.pathName,
    categoryPathName,
  );

  const label = isSingleServiceLink
    ? service.translatedKey
    : (service as any).translatedViewAllKey;

  const dataHook = isSingleServiceLink
    ? dataHooks.mobileServiceLink(service.displayKey)
    : dataHooks.mobileCategoryLink(service.displayKey);

  return (
    <div key={service?.displayKey} role="listitem">
      <Box display="block" padding="SP2 0 SP2 SP8">
        <TextButton
          as="a"
          skin="dark"
          weight="thin"
          size="medium"
          href={hrefLink}
          dataHook={dataHook}
          onClick={() => {
            logger.report(
              marketplaceHeaderClientGenericClick({
                clickType: 'choose service',
                click_data: service.displayKey,
                pageName,
              }),
            );
          }}
        >
          {label}
        </TextButton>
      </Box>
    </div>
  );
};

export default MarketplaceServiceLink;
